import { type, px2vw } from "@/libs/tools";

const style = (el, { value }) => {
  if (type(value) !== "object") {
    console.warn("Parameter must be an object");
  }

  const reg = /px$/i;
  Object.keys(value).forEach(key => {
    if (reg.test(value[key])) {
      el.style[key] = px2vw(value[key].slice(0, -2));
    } else {
      el.style[key] = value[key];
    }
  });
};

export default style;
